import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Language = 'en' | 'zh';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private currentLang = new BehaviorSubject<Language>('en');
  currentLang$ = this.currentLang.asObservable();

  constructor() {
    // Check if language preference is stored in localStorage
    const savedLang = localStorage.getItem('preferredLanguage') as Language;
    if (savedLang) {
      this.setLanguage(savedLang);
    }
  }

  setLanguage(lang: Language) {
    this.currentLang.next(lang);
    localStorage.setItem('preferredLanguage', lang);
  }

  getCurrentLang(): Language {
    return this.currentLang.value;
  }
}
